export var MediaPermission;

(function (MediaPermission) {
  MediaPermission["Granted"] = "granted";
  MediaPermission["Prompt"] = "prompt";
  MediaPermission["Denied"] = "denied";
})(MediaPermission || (MediaPermission = {}));